import type { BoxProps, TooltipProps } from '@chakra-ui/react';
import { Box, Tooltip, useDisclosure } from '@chakra-ui/react';
import React from 'react';

type MobileSupportTooltipProps = TooltipProps & { boxProps?: BoxProps };

/**
 * A standard tooltip, but it will also work on mobile by clicking on the element, like a popover
 *
 * @param props
 * @returns
 */
function MobileSupportTooltip(props: MobileSupportTooltipProps) {
  const { boxProps, ...tooltipProps } = props;
  const { isOpen, onOpen, onToggle, onClose } = useDisclosure();

  return (
    <Tooltip isOpen={isOpen} {...tooltipProps}>
      <Box
        onClick={onToggle}
        onMouseLeave={onClose}
        onMouseEnter={onOpen}
        {...boxProps}
      >
        {props.children}
      </Box>
    </Tooltip>
  );
}

export default MobileSupportTooltip;
